var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgRss3(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.032 4.947H4.295V2h13.6c1.726 0 5.566.901 7.115 4.505 1.937 4.505-.378 7.832-1.768 9.053-1.223 1.075-2.152 1.301-3.017 1.512l-.351.088c-.775.202-1.474.084-1.727 0l6.821 10.526h2.906V30h-9.516v-2.316h3.074l-6.569-10.316h-4.842v10.316h2.906V30H4v-2.316h3.032V4.947zm2.947 9.6v-9.81h8.083c1.291.098 4.025 1.044 4.632 4.042.758 3.746-2.442 5.515-3.874 5.767-1.144.203-6.37.085-8.84 0z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRss3);
export default __webpack_public_path__ + "static/media/RSS3.b2166ce97837b30822962aaf4519f742.svg";
export { ForwardRef as ReactComponent };